<script lang="ts" setup>
import { CONTEXT_COLOR_NAMES } from '../constants/colors'

const emit = defineEmits<{
  (e: 'select', color: string): void
}>()
</script>

<template>
  <ul class="grid grid-cols-3 gap-2">
    <li
      v-for="colorName in CONTEXT_COLOR_NAMES"
      :key="colorName"
    >
      <button
        class="block w-12 aspect-square rounded-3xl"
        :style="{ backgroundColor: `var(--color-context-${colorName})` }"
        @click="emit('select', colorName)"
      />
    </li>
  </ul>
</template>
